import Error from './Error';
import Warning from './Warning';
import AddFile from './AddFile';
import Policy from './Policy';
import Success from './Success';
import Checked from './Checked';

const Icons = {
  Error,
  Warning,
  AddFile,
  Policy,
  Success,
  Checked,
};

export default Icons;
